module.exports = __webpack_public_path__ + "img/3.9e8faf51.jpg";